module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAAGklEQVR4nGNgoCb4D8N37tzBilEU45OkDgAAayYnuwCSx7oAAAAASUVORK5CYII="